import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';

import '@fontsource-variable/inter';
import './styles.css';

import { Notice } from '@/components/Notice';
import { TooltipProvider } from '@/components/ui/tooltip';
import { AdminDashboardPage } from '@/pages/admin/AdminDashboardPage';
import { AdminLayout } from '@/pages/admin/AdminLayout';
import { AdminLoginPage } from '@/pages/admin/AdminLoginPage';
import { AdminMeetingDetailPage } from '@/pages/admin/AdminMeetingDetailPage';
import { AdminMeetingsPage } from '@/pages/admin/AdminMeetingsPage';
import { AdminNewMeetingPage } from '@/pages/admin/AdminNewMeetingPage';
import { JoinPage } from '@/pages/JoinPage';
import { LandingPage } from '@/pages/LandingPage';

const container = document.getElementById('root');
if (!container) throw new Error('#root is missing from index.html');

createRoot(container).render(
  <StrictMode>
    <TooltipProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />

          {/* Admin console. Declared before the /:code catch-all, or "admin"
              would be read as a meeting code. */}
          <Route path="/admin/login" element={<AdminLoginPage />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminDashboardPage />} />
            <Route path="meetings" element={<AdminMeetingsPage />} />
            {/* Static segment before the dynamic one, so "new" is not read as
                a meeting id. */}
            <Route path="meetings/new" element={<AdminNewMeetingPage />} />
            <Route path="meetings/:id" element={<AdminMeetingDetailPage />} />
          </Route>

          {/* Meeting codes look like abc-defg-hij. */}
          <Route path="/:code" element={<JoinPage />} />
          <Route
            path="*"
            element={
              <Notice title="Page not found" tone="error">
                <p>Open the interview link you were sent.</p>
              </Notice>
            }
          />
          <Route path="/index.html" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  </StrictMode>,
);
